import React, { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { BEFORE_AFTER } from "../mock";

const BeforeAfter = () => {
  const [pos, setPos] = useState(50);
  const dragRef = useRef(false);
  const wrapRef = useRef(null);

  const handleMove = (clientX) => {
    if (!wrapRef.current) return;
    const rect = wrapRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const p = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setPos(p);
  };

  return (
    <section className="bg-[#FFF2EC]">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <div className="text-center mb-10">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#DD4D2A] font-semibold mb-3">
            Real Results
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1A1410]">
            Amazing <span className="italic">Results</span>
          </h2>
          <p className="mt-4 text-[#1A1410]/70 max-w-xl mx-auto">
            Check out the stunning transformation our product delivered for one
            of our customers!
          </p>
        </div>

        <div
          ref={wrapRef}
          onMouseMove={(e) => dragRef.current && handleMove(e.clientX)}
          onMouseUp={() => (dragRef.current = false)}
          onMouseLeave={() => (dragRef.current = false)}
          onTouchMove={(e) => handleMove(e.touches[0].clientX)}
          className="relative w-full max-w-4xl mx-auto aspect-[16/10] md:aspect-[16/9] rounded-3xl overflow-hidden select-none cursor-ew-resize bg-[#FFE4D6]"
        >
          <img
            src={BEFORE_AFTER.before}
            alt="Before"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div
            className="absolute inset-0 overflow-hidden"
            style={{ width: `${pos}%` }}
          >
            <img
              src={BEFORE_AFTER.after}
              alt="After"
              className="absolute inset-0 h-full object-cover"
              style={{ width: wrapRef.current?.clientWidth || "100%" }}
            />
          </div>

          {/* Labels */}
          <div className="absolute top-4 left-4 bg-[#DD4D2A] text-white text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full">
            After
          </div>
          <div className="absolute top-4 right-4 bg-[#1A1410]/80 text-white text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full">
            Before
          </div>

          {/* Divider */}
          <div
            className="absolute top-0 bottom-0 w-0.5 bg-white"
            style={{ left: `calc(${pos}% - 1px)` }}
          />
          <button
            onMouseDown={() => (dragRef.current = true)}
            onTouchStart={() => (dragRef.current = true)}
            className="ba-handle absolute top-1/2 -translate-y-1/2 w-11 h-11 bg-[#DD4D2A] text-white rounded-full flex items-center justify-center"
            style={{ left: `calc(${pos}% - 22px)` }}
            aria-label="Drag to compare"
          >
            <MoveHorizontal className="w-5 h-5" />
          </button>
        </div>

        <p className="text-center mt-6 text-sm text-[#1A1410]/60">
          Drag the slider to see the difference
        </p>
      </div>
    </section>
  );
};

export default BeforeAfter;
